<template>
	<v-container>
		<h1>Acerca de</h1>
		<v-row>
			<v-col>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'About',
	components: {
	}
}
</script>
